<template>
  <nav class="app-navigation">
    <div class="app-navigation__section">
      <p class="app-navigation__label">Workspace</p>
      <button type="button" class="app-navigation__item" :class="{ 'is-active': isLibraryActive }" @click="activateMode('all')">
        <span class="app-navigation__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M8 4v4H4V4zm2-2H2v8h8zm8 2v4h-4V4zm2-2h-8v8h8zm8 2v4h-4V4zm2-2h-8v8h8zM8 14v4H4v-4zm2-2H2v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zM8 24v4H4v-4zm2-2H2v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zm8 2v4h-4v-4zm2-2h-8v8h8z" fill="currentColor"></path></svg>
        </span>
        <span>
          <strong>Library</strong>
          <small>Browse all slide assets</small>
        </span>
      </button>
      <button type="button" class="app-navigation__item" :class="{ 'is-active': isMyLibraryActive }" @click="activateMode('my')">
        <span class="app-navigation__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20 21h-8a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-4v2h8v-2z" fill="currentColor"></path><path d="M28 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 24H6V12h20zm2-18H4V6h24v4z" fill="currentColor"></path></svg>
        </span>
        <span>
          <strong>My Library</strong>
          <small>Owned slides and full presentation decks</small>
        </span>
      </button>
      <button type="button" class="app-navigation__item" :class="{ 'is-active': isWishlistActive }" @click="activateMode('favourites')">
        <span class="app-navigation__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M22.45 6a5.47 5.47 0 0 1 3.91 1.64a5.7 5.7 0 0 1 0 8L16 26.13L5.64 15.64a5.7 5.7 0 0 1 0-8a5.48 5.48 0 0 1 7.82 0l2.54 2.6l2.53-2.58A5.44 5.44 0 0 1 22.45 6m0-2a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0a7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z" fill="currentColor"></path></svg>
        </span>
        <span>
          <strong>Wishlist</strong>
          <small>Saved slides for later</small>
        </span>
      </button>
    </div>

    <div class="app-navigation__section">
      <p class="app-navigation__label">Account</p>
      <router-link class="app-navigation__item app-navigation__item--link" :class="{ 'is-active': route.name === 'orders' }" to="/orders">
        <span class="app-navigation__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 4l5 5h-3v4h-4v-4H7l5-5z" fill="currentColor"/></svg>
        </span>
        <span>
          <strong>Orders &amp; downloads</strong>
          <small>Re-download your purchases</small>
        </span>
      </router-link>
      <router-link class="app-navigation__item app-navigation__item--link" :class="{ 'is-active': route.name === 'profile' }" to="/profile">
        <span class="app-navigation__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 12a5 5 0 1 0-5-5a5 5 0 0 0 5 5zm0 2c-4.42 0-8 2.24-8 5v1h16v-1c0-2.76-3.58-5-8-5z" fill="currentColor"/></svg>
        </span>
        <span>
          <strong>Profile</strong>
          <small>Personal data and email</small>
        </span>
      </router-link>
      <router-link class="app-navigation__item app-navigation__item--link" :class="{ 'is-active': route.name === 'subscription' }" to="/subscription">
        <span class="app-navigation__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 4h14V6H5zm3 5v2h4v-2zm6 0v2h2v-2z" fill="currentColor"/></svg>
        </span>
        <span>
          <strong>Subscription</strong>
          <small>Credits and billing options</small>
        </span>
      </router-link>
      <a class="app-navigation__item app-navigation__item--link" href="https://infodiagram.com" target="_blank" rel="noreferrer">
        <span class="app-navigation__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14 3h7v7h-2V6.41l-9.29 9.3l-1.42-1.42l9.3-9.29H14zm5 16H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2z" fill="currentColor"/></svg>
        </span>
        <span>
          <strong>Website</strong>
          <small>Plans, support and examples</small>
        </span>
      </a>
      <button type="button" class="app-navigation__item app-navigation__item--logout" @click="onLogout">
        <span class="app-navigation__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z" fill="currentColor"/></svg>
        </span>
        <span>
          <strong>Logout</strong>
          <small>Sign out of your account</small>
        </span>
      </button>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFilterStore } from '@/stores/useFilterStore'
import { useAuthStore } from '@/stores/useAuthStore'
import { useRoute, useRouter } from 'vue-router'

const filterStore = useFilterStore()
const authStore = useAuthStore()
const route = useRoute()
const router = useRouter()

async function onLogout() {
  await authStore.logout()
  ;(window as any).$chatwoot?.reset()
  router.push({ name: 'login' })
}

const isBrowseRoute = computed(() => route.name === 'browse')
const isLibraryActive = computed(() => isBrowseRoute.value && filterStore.mode === 'all')
const isMyLibraryActive = computed(() => isBrowseRoute.value && filterStore.mode === 'my')
const isWishlistActive = computed(() => isBrowseRoute.value && filterStore.mode === 'favourites')

function loadFavourites() {
  filterStore.clearFiltering()
  filterStore.toggleMode('favourites')
}

function loadMySlides() {
  filterStore.clearFiltering()
  filterStore.toggleMode('my')
}

async function activateMode(mode: 'all' | 'my' | 'favourites') {
  if (mode === 'all') {
    filterStore.clearFiltering()
  } else if (mode === 'my') {
    loadMySlides()
  } else {
    loadFavourites()
  }
  if (route.name !== 'browse') {
    await router.push({ name: 'browse' })
  }
}
</script>

<style lang="scss">
.app-navigation {
  display: flex;
  flex-direction: column;
  gap: 22px;
  width: 100%;
  &__section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  &__label {
    margin: 0 0 4px;
    font-size: 11px;
    line-height: 1;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.52);
  }
  &__item {
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    padding: 12px 14px;
    border: 1px solid transparent;
    border-radius: 18px;
    background: transparent;
    color: #f5f2f8;
    text-align: left;
    transition: background-color 0.22s ease, border-color 0.22s ease, transform 0.22s ease, color 0.22s ease;
    strong,
    small {
      display: block;
    }
    strong {
      font-size: 15px;
      font-family: "Montserrat", sans-serif;
      font-weight: 600;
      color: inherit;
    }
    small {
      margin-top: 2px;
      font-size: 12px;
      line-height: 1.35;
      color: rgba(245, 242, 248, 0.66);
    }
    &:hover,
    &:focus-visible {
      transform: translateX(2px);
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.08);
      color: #fff;
    }
    &.is-active {
      background: linear-gradient(135deg, rgba(247, 153, 57, 0.28), rgba(145, 61, 136, 0.34));
      border-color: rgba(255, 255, 255, 0.16);
      box-shadow: 0 14px 32px rgba(18, 12, 38, 0.24);
    }
    &.is-active small {
      color: rgba(255, 255, 255, 0.82);
    }
    &--link {
      text-decoration: none;
    }
    &--logout {
      .app-navigation__icon {
        background: rgba(220, 80, 80, 0.14);
        color: #ff9e9e;
      }
      &:hover,
      &:focus-visible {
        background: rgba(220, 80, 80, 0.12);
        border-color: rgba(220, 80, 80, 0.2);
      }
    }
  }
  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.08);
    color: #ffbf79;
    svg {
      width: 20px;
      height: 20px;
    }
  }
}

@media screen and (max-width: 991px) {
  .app-navigation {
    gap: 18px;
    &__item {
      padding: 11px 12px;
    }
  }
}
</style>
